import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteImageApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteImage = createAsyncThunk('deleteImage', async (payload) => {
  return await deleteImageApi(payload);
});

const deleteImageSlice = createSlice({
  name: 'deleteImage', // Unique Name
  initialState,
  reducers: {
    deleteImageReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteImage.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteImage.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteImage.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteImageReset } = deleteImageSlice.actions;

export default deleteImageSlice.reducer;
